import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

export type GestionTab = 'estado-tramite' | 'factura' | 'revocar';

@Component({
  selector: 'app-gestion-hub',
  templateUrl: './gestion-hub.component.html',
  styleUrls: ['./gestion-hub.component.css'],
  standalone: false
})
export class GestionHubComponent implements OnInit, OnDestroy {
  activeTab: GestionTab = 'estado-tramite';

  private readonly destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.syncFromRoute();
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.syncFromRoute());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get pageTitle(): string {
    switch (this.activeTab) {
      case 'factura':
        return 'Gestión · Descargar factura';
      case 'revocar':
        return 'Gestión · Revocar certificado';
      default:
        return 'Gestión · Estado del trámite';
    }
  }

  get pageSubtitle(): string {
    switch (this.activeTab) {
      case 'factura':
        return 'Consulta y descarga el PDF de tu factura con orden, identificación o número.';
      case 'revocar':
        return 'Valida tu identidad, elige el certificado y confirma el motivo de revocación.';
      default:
        return 'Consulta el avance de tus solicitudes con tipo y número de documento.';
    }
  }

  private syncFromRoute(): void {
    const child = this.route.firstChild?.snapshot.url[0]?.path;
    if (child === 'factura' || child === 'revocar' || child === 'estado-tramite') {
      this.activeTab = child;
      return;
    }
    this.activeTab = 'estado-tramite';
  }
}
